import { vars } from '@etg/wings';
import { css, cx } from '@eti/styles';
import { CalendarDots } from '@phosphor-icons/react';
import type { DEPARTURE_DATE, RETURN_DATE } from '../constants/formFieldNames';

const calendarButtonStyles = css`
  align-items: center;
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 2.75rem;
  justify-content: center;
  transition: background 0.2s ease-in-out;
  width: 2.75rem;

  &:focus-visible {
    outline: 2px solid ${vars.colors.focusRing};
  }
`;

const calendarButtonExpandedStyles = css`
  & > svg {
    background: ${vars.colors.inputs.tint};
  }
`;

const calendarButtonContainerStyles = css`
  bottom: 0;
  display: flex;
  inset-inline-end: 0;
  place-items: center;
  position: absolute;
  top: 0;
  z-index: 3;
`;

export interface CalendarButtonProps {
  'aria-controls': string;
  'aria-expanded': boolean;
  'aria-label'?: string;
  boundIndex: number;
  fieldName: typeof DEPARTURE_DATE | typeof RETURN_DATE;
  onClick: (fieldName: typeof DEPARTURE_DATE | typeof RETURN_DATE) => void;
}

const CalendarButton = ({
  'aria-controls': ariaControls,
  'aria-expanded': ariaExpanded,
  'aria-label': ariaLabel,
  boundIndex,
  fieldName,
  onClick,
}: CalendarButtonProps) => {
  const handleOnClick = () => {
    onClick(fieldName);
  };

  return (
    <div className={calendarButtonContainerStyles}>
      <button
        aria-controls={ariaControls}
        aria-expanded={ariaExpanded}
        aria-label={ariaLabel}
        className={cx(
          calendarButtonStyles,
          ariaExpanded ? calendarButtonExpandedStyles : undefined,
        )}
        id={`calendar-icon-${fieldName}-${boundIndex}`}
        onClick={handleOnClick}
        type="button"
      >
        <CalendarDots aria-hidden size={20} />
      </button>
    </div>
  );
};

export default CalendarButton;
